import React, {
  useRef, useCallback, useEffect, useState,
} from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ModalFactory from 'react-modal-promise';
import Grid from '@material-ui/core/Grid';
import HeaderSimle from '../../../components/Headers/Simple';
import Modal from '../../../components/ModalSimple';
import getValidationError from '../../../utils/getValidationsErros';
import {
  WrapperLabel, Input, InputMask, TextArea, Button, ButtonIcon,
  Select,
  InputHidden
} from '../../../components/Forms';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import { InfoIcon, WarningIcon } from '../../../styles/icons';
import {
  Container, GridButtons, WrapperBtnInfo, WrapperBtnCancel, WrapperBtnSubmit,
  WrapperModal, Red,Img,
} from './styles';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'hooks/auth';
import { useToast } from 'hooks/toast';
import { useHttp } from 'hooks/http';
import * as Yup from 'yup';
import removeAccents from 'utils/removeAccents';
import getCurrentPosition from 'utils/getCurrentPosition';
import { format, isValid } from 'date-fns';
import { parseDate } from 'utils';
import Nuint from './Nuint';

interface IForm {
  coord: {
    lat: number,
    lng: number
  }
}

const Person2: React.FC<IForm> = ({ coord }) => {
  const history = useHistory();
  const formRef = useRef<FormHandles>(null);
  const labelRef = useRef<HTMLLabelElement>(null);
  const labelConfRef = useRef<HTMLLabelElement>(null);
  const { user } = useAuth();
  const { addToast } = useToast();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState<any>();
  const [showNuint, setShowNuint] = useState(false);
  const { httpGet, httpPost, unLoading, loading } = useHttp();
  const [btnLoading, setBtnLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [store, setStore] = useState(0);

  const [sOptions] = useState([
      { value: 1, label: 'Identidade' },
      { value: 2, label: 'Cpf' },
      { value: 50, label: 'Dados Pessoais' },
      { value: 100, label: 'Nucleo de Inteligência - Nuint' },
    ]);

    function isValidCPF(input: unknown): boolean {
      if (typeof input !== 'string' && typeof input !== 'number') return false;

      let cpf = String(input).replace(/[^\d]+/g, '');

      if (cpf.length !== 11) return false;
      if (/^(\d)\1{10}$/.test(cpf)) return false;

      const calcCheckDigit = (base: string, factor: number): number => {
        let total = 0;
        for (let i = 0; i < base.length; i++) {
          total += parseInt(base[i]) * factor--;
        }
        const remainder = total % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };

  const baseCPF = cpf.substring(0, 9);
  const firstDigit = calcCheckDigit(baseCPF, 10);
  const secondDigit = calcCheckDigit(baseCPF + firstDigit, 11);

  return cpf === baseCPF + firstDigit.toString() + secondDigit.toString();
    }
  
  useEffect(() => {
    unLoading();
  }, [unLoading, loading]);

  const handleGetPerson = useCallback(async () => {
    const is_select = formRef.current?.getFieldValue('is_select');
    const osp = formRef.current?.getFieldValue('osp');
    const document = formRef.current?.getFieldValue('document');
    const document_secondary = formRef.current?.getFieldValue('document_secondary');
    const name = formRef.current?.getFieldValue('name');
    const birthday = formRef.current?.getFieldValue('birthday');
    const mather = formRef.current?.getFieldValue('mather');

    const person = {
      osp: osp,
      is_select: is_select?.value,
      document_secondary: document_secondary ? document_secondary?.replace(/\D/g, ''): null,
      document: document ? document?.replace(/\D/g, ''): null,
      name: name && removeAccents(name?.trim()),
      mather: mather && removeAccents(mather?.trim()),
      birthday: birthday && birthday,
    };

    const validationSchema = Yup.object().shape({
      is_select: Yup.number().nullable().required('Seleção é obrigatória'),
    
      document: Yup.string().nullable().when('is_select', (is_select: number, schema: Yup.StringSchema) => 
        is_select === 2 ? schema.required('CPF é obrigatório') : schema.notRequired()
      ),
    
      document_secondary: Yup.string().nullable().when('is_select', (is_select: number, schema: Yup.StringSchema) => 
        is_select === 1 ? schema.required('RG é obrigatório') : schema.notRequired()
      ),
    
      cnh: Yup.string().nullable().when('is_select', (is_select: number, schema: Yup.StringSchema) => 
        is_select === 4 ? schema.required('CNH é obrigatória') : schema.notRequired()
      ),

      name: Yup.string().nullable().when('is_select', (is_select: number, schema: Yup.StringSchema) => 
        is_select === 50  || is_select === 100 ? schema.required('Nome é obrigatória') : schema.notRequired()
      ),

      mather: Yup.string().nullable().when('is_select', (is_select: number, schema: Yup.StringSchema) => 
        is_select === 50  || is_select === 100 ? schema.required('Mãe é obrigatória') : schema.notRequired()
      ),

      birthday: Yup.string().nullable().when('is_select', (is_select: number, schema: Yup.StringSchema) => 
        is_select === 50  || is_select === 100 ? schema.required('Nascimento é obrigatória') : schema.notRequired()
      ),
    
    });
        
    try {
      formRef.current?.setErrors({});

      await validationSchema.validate(person, {
        abortEarly: false,
      });

      setBtnLoading(true);
      const position = await getCurrentPosition();
      
      if (person.is_select === 100) {
        const date = new Date(person?.birthday);
        const response: any = await httpPost('orders', {
          ...person,
          birthday: isValid(date) ? format(date, 'yyyy-MM-dd') : '',
          ...coord,
          management_id: user?.allocation?.management_id,
          type: 'person',
          current_lat: position.lat,
          current_lng: position.lng,
        });
        if (response.response?.status === 302) {
          const { data } = response.response;
          history.push(`/order/detail/${data.id}`);
        }
  
        if (response.status === 200) {
          history.push('/orders/latest');
        }
  
        if (response.status !== 200) {
          setBtnLoading(false);
        }
      } else {
      const response: any = await httpGet('/orders/autocomplete/detran', { params: { ...person } });
      if (response.status === 200) {
        const { data } = response;
        setBtnLoading(false);

        if (data.MsgRetorno === 'Cidadão não encontrado'
          || data.MsgRetorno === 'Não existe solicitação de Processamento em aberto para este ID.') {
          addToast({ type: 'error', title: data.MsgRetorno });
        } else if (data?.RG !== 0) {

          setFormData(
            {
              document: isValidCPF(data?.CPF) ? String(data?.CPF).padStart(11, '0') : false,
              document_secondary: data?.RG,
              name: data?.NoCidadao,
              birthday: data?.DtNascimento,
              mather: data?.NoMaeCidadao,
              father: data?.NoPaiCidadao,
              gender: data?.Sexo,
              foto: `data:image/png;base64,${data?.fotoCivil?.string}`
            });

            formRef.current?.setData({
              ...data,
              is_select: is_select, // Preserva o valor do select
              document: isValidCPF(data?.CPF) ? String(data?.CPF).padStart(11, '0') : false,
              document_secondary: data?.RG,
              name: data?.NoCidadao,
              birthday: data?.DtNascimento,
              mather: data?.NoMaeCidadao,
              father: data?.NoPaiCidadao,
              gender: data?.Sexo,
              confirmed: [{ value: null, label: '' }],
            });
          labelConfRef.current?.click();
        } else {
          addToast({ title: data.MsgRetorno });
        }
      } else {
        addToast({  
          type: 'error' , 
          title: "Ocorreu algum erro, ou serviço está fora!", 
          description: "Você será redirecionado..."
        });
        await new Promise(resolve => setTimeout(resolve, 5000));
        setBtnLoading(false);
        setShowNuint(true);
      }
    }
    setBtnLoading(false);
    } catch (err) {
      console.error("err ", err)
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
        formRef.current?.setErrors(erros);
        setBtnLoading(false);
      }
    }
  
  },[httpGet, history, httpPost, addToast, coord, user])

  const isMounted = useRef(true);
  useEffect(() => {
      isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleSubmit = useCallback(async (data: any) => { 
      const personSubmit = {
        ...data,
        document: data.document ? data.document?.replace(/\D/g, ''): null,
        birthday: parseDate(data.birthday),
        ...coord,
        management_id: user?.allocation?.management_id,
        type: 'person',
      };

    setBtnLoading(true);
    try {
    const position = await getCurrentPosition();

    const response: any = await httpPost('orders/sipol', {
      ...personSubmit,
      current_lat: position.lat,
      current_lng: position.lng,
    });

    if (response.response?.status === 302) {
      const { data } = response.response;
      history.push(`/order/detail/${data.id}`);
      return
    }

    if (response.status === 200) {
      history.push('/orders/latest');
      return 
    }

  } catch (err) {
    console.error(err);
  } finally {
      if (isMounted.current) {
        setBtnLoading(false);
      }
    }
  },[coord, history, httpPost, user])

  const handleChangeChecked = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisableBtn(event.target.checked);
  }, []);

  const handleHover = useCallback(() => {
    setDisableBtn(false);
    setShowForm(false)
    labelConfRef.current?.click();

    // Preserva o valor do select antes de resetar
    const currentSelectValue = formRef.current?.getFieldValue('is_select');
    formRef.current?.reset();

    // Restaura o valor do select após o reset
    if (currentSelectValue) {
      formRef.current?.setFieldValue('is_select', currentSelectValue);
    }

    setFormData(null)
  }, []);

  const handleFieldStore = useCallback((assistance: any) => {
      if(!assistance) return 
      const { value } = assistance;
      setStore(value);
  }, []);

  if (showNuint) {
    return <Nuint coord={coord} />;
  }

  return (
    <>
      <HeaderSimle>
        Buscar pessoas
      </HeaderSimle>
      <Container>
        <UForm ref={formRef} onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <WrapperLabel label="Selecione" xs={12} md={12}>
              <Select
                name="is_select"
                options={sOptions}
                onChange={handleFieldStore}
              />
            </WrapperLabel>
            <span style={{ color: 'red', fontSize: 12, marginBottom: 8 }}>
              * Busca por Identidade, cpf e dados pessoais: Em período de teste. 
            </span>
  
            {store === 1 && (
              <>
                <WrapperLabel label="Rg" xs={12}>
                  <Input name="document_secondary" type="tel" />
                </WrapperLabel>
                <WrapperLabel label="Observação" xs={12}>
                  <TextArea row={2} name="description" />
                </WrapperLabel>
                <InputHidden name="document" type="tel" />
                <InputHidden name="name" style={{ textTransform: 'uppercase' }} />
                <InputHidden name="birthday" placeholder="DD/MM/YYYY"/>
                <InputHidden name="mather" style={{ textTransform: 'uppercase' }}  />
                <InputHidden name="father" style={{ textTransform: 'uppercase' }}  />
                <InputHidden name="gender" style={{ textTransform: 'uppercase' }}  />
                <InputHidden name="foto" value={formData?.foto ?? ""} readOnly />
              </>
            )}
            {store === 2 && (
              <>
                <WrapperLabel label="Cpf" xs={12}>
                  <InputMask
                    name="document"
                    type="tel"
                    mask="999.999.999-99"
                  />
                </WrapperLabel>
                <WrapperLabel label="Observação" xs={12}>
                  <TextArea row={2} name="description" />
                </WrapperLabel>
                <InputHidden name="document_secondary" type="tel" />
                <InputHidden name="name" style={{ textTransform: 'uppercase' }} />
                <InputHidden name="birthday" placeholder="DD/MM/YYYY"/>
                <InputHidden name="mather" style={{ textTransform: 'uppercase' }}  />
                <InputHidden name="father" style={{ textTransform: 'uppercase' }}  />
                <InputHidden name="gender" style={{ textTransform: 'uppercase' }}  />
                <InputHidden name="foto" value={formData?.foto ?? ""} readOnly />
              </>
            )}
            {store === 50 && (
            <>
              <WrapperLabel label="Nome" xs={12}>
                <Input name="name" style={{ textTransform: 'uppercase' }} />
              </WrapperLabel>
              <WrapperLabel label="Nascimento" xs={12} sm={6}>
                <InputMask name="birthday" mask="99/99/9999" placeholder="DD/MM/YYYY" type="tel" />
              </WrapperLabel>
              <WrapperLabel label="Mãe" xs={12} sm={6}>
                <Input name="mather" style={{ textTransform: 'uppercase' }}  />
              </WrapperLabel>
              <WrapperLabel label="Observação" xs={12}>
                <TextArea row={2} name="description" />
              </WrapperLabel>
              <InputHidden name="document_secondary" />
              <InputHidden name="document" />
              <InputHidden name="foto" value={formData?.foto ?? ""} readOnly />
            </>
            )}
            {store === 100 && (
            <>
              <InputHidden name="osp"/>
              <WrapperLabel label="CPF" xs={12} sm={6}>
                <InputMask name="document" type="tel" mask="999.999.999-99" />
              </WrapperLabel>
              <WrapperLabel label="RG" xs={12} sm={6}>
                <Input name="document_secondary" type="tel" />
              </WrapperLabel>
              <WrapperLabel label="Nome" xs={12} sm={6}>
                <Input name="name" />
              </WrapperLabel>
              <WrapperLabel label="Nascimento" xs={12} sm={6}>
                <InputMask name="birthday" mask="99/99/9999" placeholder="DD/MM/YYYY" type="tel" />
              </WrapperLabel>
              <WrapperLabel label="Mãe" xs={12} sm={6}>
                <Input name="mather" />
              </WrapperLabel>
              <WrapperLabel label="Pai" xs={12} sm={6}>
                <Input name="father" />
              </WrapperLabel>
              <WrapperLabel label="Observação" xs={12}>
                <TextArea row={2} name="description" />
              </WrapperLabel>
            </>
          )}
          </Grid>
          <GridButtons>
            <WrapperBtnInfo>
              <ButtonIcon
                title="Instruções"
                onClick={() => labelRef.current?.click()}
              >
                <InfoIcon />
              </ButtonIcon>

              <label ref={labelRef} htmlFor="modal-instruction" />
              <Modal id="modal-instruction" width={520} height="auto">
                <h1>Instruções</h1><br />
                <p>
                  Para solicitar uma consulta de pessoa você precisa no mínimo
                  informar os seguintes dados:
                </p><br />
                <p><b>Nome e RG</b> ou</p>
                <p><b>Nome e Nascimento</b> ou</p>
                <p><b>Nome e Mãe</b> ou</p>
                <p><b>Nome e Pai</b>.</p>
                <br />
              </Modal>

            </WrapperBtnInfo>
            <WrapperBtnCancel>
              <Button
                type="button"
                onClick={() => { history.push('/dashboard'); }}
              >
                Cancelar
              </Button>
            </WrapperBtnCancel>
            <WrapperBtnSubmit>
              <Button
                type="button"
                onClick={() => {
                  if (showForm) {
                    formRef.current?.submitForm();
                  } else {
                    handleGetPerson();
                  }
                }}
                isLoading={btnLoading}
              >
                Consultar
              </Button>
            </WrapperBtnSubmit>
          </GridButtons>
        </UForm>
        <WrapperModal>
        <label ref={labelConfRef} htmlFor="modal-conf" />
        <Modal id="modal-conf" width={520} height="auto">
          <h2>
            <WarningIcon /> Confirma os dados da pessoa consultada ?
          </h2>
          {formData?.document_secondary && (
          <p>RG: <b>{formData?.document_secondary}</b></p>
          )}
          {formData?.document && (
          <p>Cpf: <b>{formData?.document}</b></p>
          )}
          {formData?.name && (
            <p>Nome: <b>{formData?.name}</b></p>    
          )}
          <p>Nascimento: <b>{formData?.birthday}</b></p>
          <p>Mãe: <b>{formData?.mather}</b></p>
          {formData?.foto && (
              <p><Img src={formData?.foto} id="foto" width={100} height={120} /></p> 
          )}
          <FormControlLabel
            label={<Red>Confirmo as informações acima.</Red>}
            control={(
              <Switch
                onChange={handleChangeChecked}
                color="primary"
                name="checked"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            )}
          />

          <span>
            <Button
              onClick={handleHover}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => formRef.current?.submitForm()}
              isLoading={btnLoading}
              disableForce={!disableBtn}
            >
              Confirmar
            </Button>
          </span>
        </Modal>
      </WrapperModal>
      <ModalFactory />
      </Container>
    </>
  )
};

export default Person2;

